<template>
  <Button
    :loading="loading || getUserFb && getUserFb.token && true"
    @click="clickFacebook"
    type="facebook"
    icon="facebook"
    :title="getUserStatus == 'unknown' ? 'Entrar com Facebook' :
            getUserStatus == 'connected' ? 'Por favor, complete seus dados.' :
            getUserStatus == 'not_authorized' ? 'Não autorizado' : 'Entrar com Facebook'"
  />
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import api from '../../services/api'
import common from '../../mixins/common'

import Button from '../Button'

export default {
  name: 'Facebook',
  mixins: [common],
  components: {
    Button
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getUserFb', 'getUserStatus'])
  },
  methods: {
    ...mapMutations(['setModal', 'setUserFb', 'setUserStatus']),
    ...mapActions(['addAlert', 'clearAlert']),
    async statusChangeCallback (logged) {
      this.clearAlert()
      try {
        this.setUserStatus(logged.status)
        if (logged.status === 'connected') {
          const response = await api.post('/users/fblogin', {
            client_type: this.clientType,
            establishment_id: this.establishmentId,
            token: logged.authResponse.accessToken
          })

          this.setUserFb(response.data)
          if (response.data.token) {
            this.addAlert({
              type: 'success',
              icon: 'checkbox-marked-circle-outline',
              title: 'Bem vindo! Estamos redirecionando para sua página!'
            })
            this.redirect(response.data.token)
          } else {
            this.addAlert({
              type: 'success',
              icon: 'checkbox-marked-circle-outline',
              title: "Por favor, complete seus dados em 'Cadastre-se'!"
            })
            this.setModal('register')
          }
          this.loading = false
        }
        if (logged.status === 'not_authorized') {
          this.loading = false
        }
        if (logged.status === 'unknown') {
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    clickFacebook () {
      this.loading = true
      console.log()
      if (this.getUserFb === null || this.getUserFb.status === 'unknown') {
        try {
          window.FB.login((response) => {
            this.statusChangeCallback(response)
          })
        } catch (error) {
          console.log(error)
        }
      } else if (this.getUserFb.status === 'connected') {
        this.setModal('register')
      } else if (this.getUserFb.status === 'not_authorized') {
        window.FB.logout()
      }
    }
  }
}
</script>
